// Login screen and user management.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.
//
// FLIXALIO and FLIXPECTOR share one user base, so these read the same in both
// apps: Anmelden / Benutzername / Passwort / Benutzerverwaltung / Rolle.

export const auth: Record<string, string> = {
  // LoginPage
  'Sign in with your FLIXALIO account': 'Mit deinem FLIXALIO-Konto anmelden',
  Username: 'Benutzername',
  Password: 'Passwort',
  'Sign in': 'Anmelden',
  'Signing in …': 'Anmelden …',
  'Contact your administrator to get an account':
    'Für ein Konto wende dich an deine Administratorin oder deinen Administrator',

  // AdminPage
  'User management': 'Benutzerverwaltung',
  'Add user': 'Benutzer anlegen',
  'Create new user': 'Neuen Benutzer anlegen',
  'Edit user': 'Benutzer bearbeiten',
  'Really delete the user "{name}"?': 'Benutzer „{name}“ wirklich löschen?',
  'Users could not be loaded': 'Benutzer konnten nicht geladen werden',
  'User could not be created': 'Benutzer konnte nicht angelegt werden',
  'User could not be deleted': 'Benutzer konnte nicht gelöscht werden',
  'User could not be saved': 'Benutzer konnte nicht gespeichert werden',
  'Full name': 'Voller Name',
  Initials: 'Kürzel',
  'Optional, e.g. LEW — shown in Flixpector on every line. Empty = derived from the name.':
    'Optional, z. B. LEW — erscheint in Flixpector pro Zeile. Leer = aus dem Namen abgeleitet.',
  Email: 'E-Mail',
  Role: 'Rolle',
  User: 'Benutzer',
  'At least 8 characters': 'Mindestens 8 Zeichen',
  'Last login': 'Letzte Anmeldung',
  Never: 'Nie',
  Active: 'Aktiv',
  Inactive: 'Inaktiv',
}
